import { LayoutDashboard, Package, Tags, ClipboardList } from "lucide-react";

export const SIDEBAR_MENU = [
  { name: "대시보드", href: "/dashboard", icon: LayoutDashboard },
  { name: "품목", href: "/items", icon: Tags },
  { name: "재고", href: "/inventory", icon: Package },
  { name: "발주", href: "/orders", icon: ClipboardList },
] as const;
